import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    //location: any;
    //bgClass: any;

    //constructor(
    //    private router: Router,
    //    location: Location
    //) {
    //    this.router.events
    //        .subscribe((event) => {
    //            if (event instanceof NavigationEnd) {
    //                this.location = this.router.url;
    //                if (this.location == '/' || this.location == '/index-2' || this.location == '/index-3' || this.location == '/about') {
    //                    this.bgClass = '';
    //                } else {
    //                    this.bgClass = 'bg-f5f5f5';
    //                }
    //            }
    //        });
    //}

    ngOnInit(): void {
    }

}
